const DEFAULT_MAIN_LINK_KEYS = ['prices', 'learn', 'individuals', 'businesses', 'institutions', 'developers', 'company'];
const FLOATING_HEADER_PX_BREAKPOINT = 100;
const TRAPDOOR_ANIMATION_MS = 150;
const MOBILE_BREAKPOINT = 1050;
const COUNTRY_BANNER_COOKIE_KEY = 'hide_country_banner';
const COINBASE_LOGO_MAP = {
  blue: 'https://images.ctfassets.net/q5ulk4bp65r7/7CVqRBllUwseIXWjHInAhV/13238df422bdb9c0d485bda6caa90385/coinbase-logo-svg.svg',
  white: 'https://images.ctfassets.net/q5ulk4bp65r7/7kIsjZt3oxnEIndCVW28pQ/35b4e345e55abddb4e025aae8bd88248/Vector__4_.svg',
  blueNew: 'https://images.ctfassets.net/q5ulk4bp65r7/3TBS4oVkD1ghowTqVQJlqj/2dfd4ea3b623a7c0d8deb2ff445dee9e/Consumer_Wordmark.svg',
  whiteNew: 'https://images.ctfassets.net/q5ulk4bp65r7/3d0nJDFOq4TdewlmTxQ6Eb/e94dcbc5ac72d84e812bccc8561c6b62/Consumer_Wordmark_White.svg'
};
const SIGN_UP_URL = 'https://www.coinbase.com/signup';
const SIGN_IN_URL = 'https://www.coinbase.com/signin';
export { COINBASE_LOGO_MAP, COUNTRY_BANNER_COOKIE_KEY, DEFAULT_MAIN_LINK_KEYS, FLOATING_HEADER_PX_BREAKPOINT, MOBILE_BREAKPOINT, SIGN_IN_URL, SIGN_UP_URL, TRAPDOOR_ANIMATION_MS };
//# sourceMappingURL=constants.js.map
